export default __webpack_public_path__ + "static/media/productHealthCheckPackage1_all_Cn.d60de7e2.webp";